import { render } from "./SearchForm.vue?vue&type=template&id=6c80d6d4"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__